import request from '@/service/request'
//查询商品详情
const PRODUCTS_DETAIL = '/system/OfficialWebsite/productsDetail'
//查询官网首页商品分类
const GET_PRODUCT_CLASSIFY = "/system/OfficialWebsite/getProductClassify";
//查询资讯详情
const GET_INFORMATION_DETAILS = "/system/OfficialWebsite/getInformationDetails";
//查询资讯分类
const GET_INFORMATION_CLASSIFY = "/system/OfficialWebsite/getInformationClassify";
//查询一级分类
const QUERY_CATEGORY_OPERATION = "/system/OfficialWebsite/queryCategoryOperation";
//查询二级分类
const QUERY_CATEGORY_OPERATION_BY_SUB = "/system/OfficialWebsite/queryCategoryOperationBySub";
//根据商品ids查询商品列表
const QUERY_BANNER_BY_PRODUCT = "/system/OfficialWebsite/queryBannerByProduct";
//热门资讯
const GET_HOT_INFORMATION='/system/OfficialWebsite/getHotInformation'



//热门资讯
export const getHotInformation = () => {
  return request({
    url: GET_HOT_INFORMATION,
    method: "get",
  });
};
//根据商品ids查询商品列表
export const queryBannerByProduct = (data) => {
   return request({
    //  url:
    //    QUERY_BANNER_BY_PRODUCT +
    //    `?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
     url:
       QUERY_BANNER_BY_PRODUCT +
       `?id=${data.id}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
     method: "post",
     //  data: data,
   });
};
////查询商品详情
export const productsDetail = (data) => {
  return request({
    url: PRODUCTS_DETAIL+`?id=${data.id}`,
    method: "post",
  });
};
//查询二级分类
export const queryCategoryOperationBySub = (data) => {
  return request({
    url: QUERY_CATEGORY_OPERATION_BY_SUB+`?id=${data.id}`,
    method: "post",
    // data: data,
  });
};
//查询一级分类
export const queryCategoryOperation = (data) => {
  return request({
    url: QUERY_CATEGORY_OPERATION,
    method: "post",
    data: data,
  });
};
//查询官网首页商品分类
export const getProductClassify = (params) => {
  console.log(params)
  return request({
    url: GET_PRODUCT_CLASSIFY,
    method: "get",
    params: params,
  });
};
//查询资讯详情
export const getInformationDetails = (params) => {
  let url= ''
  if(params.classifyId && params.classifyId!='-999'){
    url=`?classifyId=${params.classifyId}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`
  }else{
    url = `?pageNum=${params.pageNum}&pageSize=${params.pageSize}`
  }
  return request({
    url: GET_INFORMATION_DETAILS+url,
    method: "get",
    // params: params,
  });
};
//查询资讯分类
export const getInformationClassify = (params) => {
  return request({
    url: GET_INFORMATION_CLASSIFY,
    method: "get",
    params: params,
  });
};
